<div class="modal-header">
    <incident-dialog-header [incident]="data.incident" (close)="cancel()"></incident-dialog-header>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="(null != validationResults) && (null != validationResults.validationResults) && (0 != validationResults.validationResults.length)"></validation-results>
    <h2 class="btn--h2-hack"><button class="icon--download btn--default" type="button" title="Last Reevaluated by: {{this.lastReevaluatedBy}}" *ngIf="data.incident.incidentNumberId > 0" (click)="reevaluateAndUpdateProhibition(data.incident.incidentNumberId)">Reevaluate Incident</button></h2>
    <incident-dialog-content [parent]="this" [fieldsTemplate]="fieldsTemplate" [formGroup]="incidentForm" (occurrenceDateBlur)="occurrenceDateBlur($event)" (occurrenceDateChanged)="occurrenceDateChanged($event)">
        <ng-template #fieldsTemplate>
        </ng-template>
    </incident-dialog-content>
    <form [formGroup]="incidentForm" autocomplete="off" *ngIf="showUserInput">
        <h2>Judgment Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <user-input type="list" [parent]="this" label="Court" name="courtId" id="courtId" [isRequired]="true" [list]="courts" listValueMember="id" listDisplayMember="displayName" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
                <div class="col-sm-4 mvd_form-group" *ngIf="caughtChange[0] == 212">
                    <user-input type="text" [parent]="this" label="Other Court Detail" name="otherCourtDetail"></user-input>
                </div>
            </div>
            <div class="row">

                <div class="col-sm-4 mvd_form-group">
                    <user-input type="date" [parent]="this" label="Accident Date" name="accidentDate" [isRequired]="true"></user-input>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Judgment Creditor" name="judgmentCreditor" [isRequired]="true"></user-input>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Attorney" name="attorneyName" [isRequired]="true"></user-input>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Attorney Phone Number" name="attorneyPhoneNumber" [isRequired]="true"></user-input>
                </div>

            </div>
        </fieldset>
    </form>

    <h2>Customer</h2>
    <fieldset>
        <div class="mvd_form-group" *ngIf="!data.isReadOnly">
            <customer-search-bar id="incidentCustomerSearch" [label]="'Add Customer'" (onItemSelected)="addCustomer($event)"></customer-search-bar>
        </div>
        <div class="mvd_form-group">
            <label>Existing Customer(s)</label>
            <div class="search--omni" *ngFor="let customer of data.incident.customers">
                <ul>
                    <li class="search--omni__image">
                        <customer-photo [classes]="'mvd_photo'" [customerNumberId]="customer.id" [legacySequenceNumber]="customer.legacySequenceNumber"></customer-photo>
                    </li>
                    <li>
                        <div><b>{{customer.displayName}}</b></div>
                        <div>{{customer | address}}</div>
                    </li>
                    <li class="search--omni__remove">
                        <a class="icon--remove" title="Remove" href="javascript:void(0)" (click)="confirmRemoveCustomer(customer)" *ngIf="!data.isReadOnly"></a>
                    </li>
                </ul>
            </div>
        </div>
    </fieldset>
    <incident-updated [updatedBy]="data.incident.updatedBy" [updatedDate]="data.incident.updatedDate"></incident-updated>
</div>
<div class="modal-footer">
    <incident-dialog-footer [incident]="data.incident" [isReadOnly]="data.isReadOnly" [isDisabled]="!incidentForm.valid" [isLoading]="showButtonLoading" (cancel)="cancel()" (save)="saveIncident()"></incident-dialog-footer>
</div>